module.exports = __webpack_public_path__ + "static/media/search.51946304.svg";